import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import CustomNavbar from "../../../components/CustomNavbar";
//import SidebarDashboard from '../../../components/SidebarDashboard';
import CustomTable from "../../../components/CustomTable";
import {
  getMeasurements,
  saveMeasurements,
  editMeasurements,
  deleteMeasurements,
} from "../../../redux/climalaboral/measurements/actions";
import { getCategory } from "../../../redux/climalaboral/category/actions";

import messages from "../../../redux/messages";
import SidebarConfig from "../../../components/Clima/SidebarClimate";
import CustomPagint from "../../../components/CustomPagint";

const Mediciones = () => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const dispatch = useDispatch();

  const data = useSelector((store) => store.measurements.measurements);
  // const data = [{'codigo':'fe4s','descripcion':'descripcion prueba'}];
  const dataLenght = useSelector(
    (store) => store.measurements.measurementsLength
  );
  const pages = Math.ceil(dataLenght / limit);
  const loading = useSelector((store) => store.measurements.loading);
  const saveLoading = useSelector((store) => store.measurements.saveLoading);

  const category = useSelector((store) => store.category.category);
  const categoryLenght = useSelector((store) => store.category.categoryLength);
  const categoryLoading = useSelector((store) => store.category.loading);

  const columns = [
    {
      Header: "Medición",
      accessor: "nombre",
    },
    {
      Header: "Categoría",
      accessor: "objetos_list.nombre",
    },
    {
      Header: "Ultima modificación",
      accessor: "fecha_creacion",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {userRoles.length > 0 && userRoles.includes("administrador") ? (
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          ) : null}
          {userRoles.length > 0 && userRoles.includes("administrador") ? (
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          ) : null}
        </div>
      ),
    },
  ];

  // Métodos
  const getAMeasurements = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getMeasurements({
        offset: offs,
        limit: lim,
        filter: filt,
      })
    );

  useEffect(() => {
    getAMeasurements();
    dispatch(getCategory({}));
  }, []);

  const addArea = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAMeasurements(oOffset, limit, e.target.filter.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const req = {
      nombre: e.target.medicion.value,
      objeto: e.target.categoria.value,
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };

    if (!edit) {
      dispatch(saveMeasurements(req));
      e.target.reset();
      setShowModal(false);
    } else {
      dispatch(editMeasurements(req, editItem.id, index));
      e.target.reset();
      setShowModal(false);
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAMeasurements(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteMeasurements(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Mediciones</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-2"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addArea()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            dataLenght > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={data} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={dataLenght}
                  pages={pages}
                  pagFunc={getAMeasurements}
                />
              </>
            )
          )}
          {dataLenght === 0 && (
            <Alert variant="info" className="my-4">
              Aún no hay mediciones, comienza agregando algunos
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? "Editar medición" : "Crear medición"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="4">
                Medición:
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="medicion"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.nombre : null}
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                  // pattern="[a-zA-Z][a-zA-Z\s]*"
                  // pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$"
                  placeholder="Nombre de la medición"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras,numeros y los siguientes caracteres
                  @$¿?¡\-_%#
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="categoria">
              <Form.Label column sm="12" md="4">
                Categoría:
              </Form.Label>
              <Col sm={categoryLoading ? "10" : "12"} md="8">
                <Form.Control
                  as="select"
                  id="categoria"
                  name="categoria"
                  className="rounded-pill"
                  required={!edit}
                  defaultValue={edit ? editItem.objeto : null}
                  placeholder="Categoría"
                >
                  {category
                    ? category
                        .sort((a, b) => {
                          if (a.nombre && b.nombre) {
                            if (
                              a.nombre.toLowerCase() === b.nombre.toLowerCase()
                            ) {
                              return 0;
                            }
                            if (
                              a.nombre.toLowerCase() < b.nombre.toLowerCase()
                            ) {
                              return -1;
                            }
                          }
                          return 1;
                        })
                        .map((item) => (
                          <option key={item.id} value={item.id ? item.id : ""}>
                            {item.nombre ? item.nombre.toUpperCase() : ""}
                          </option>
                        ))
                    : null}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
              {categoryLoading && (
                <Col sm="2">
                  <Spinner animation="border" size="sm" />
                </Col>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoading}
              variant="primary"
              type="submit"
            >
              {saveLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Mediciones;
